import React from 'react';
import Card from '../../../../components/LazyWidgets/Card';
import comingSoonGraphic from '../../../../assets/coming_soon_graphic.svg';
import s from './styles.module.css';

const ReportComingSoon = () => (
  <Card className={s.comingSoonCard}>
    <img className={s.comingSoonGraphic} src={comingSoonGraphic} alt="coming soon graphic" />
    <div className={s.comingSoonTitle}>Coming Soon!</div>
    <div className={s.comingSoonText}>{"We're working on enabling Reports for more courses. Until then, check out the Gradebook or the assignment landing pages to learn more about student performance."}</div>
  </Card>
);

export default ReportComingSoon;
